import {API} from "@/Composables/api";

const getContacts = async (params = {}) => {
    return API.get(route("admin.contacts.index"), params);
};

const deleteContact = async (contactId: number, params = {}) => {
    return API.delete(route("admin.contacts.destroy", contactId), params);
};

const inviteContacts = async (
    formData: {
        user_id: string;
        contacts: Array<any>;
    },
    group,
) => {
    return API.post(route("admin.invitations.store"), {group}, formData);
};

export {getContacts, inviteContacts, deleteContact};
